<template>
  <div class="holiday-main-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
        <template #right>
          <span class="tit-right" @click="handleToRule">
            <img class="left-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
          </span>
        </template>
      </van-nav-bar>
    </div>

    <div class="national-con" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <div class="national-head">
        <img class="head-img-back" src="./images/main-bg.png" />

        <div class="head-img">
          <img v-if="$i18n.locale === 'es'" :src="getMatchTitle('tit-bg-es')" />
          <img v-else-if="$i18n.locale === 'pt'" :src="getMatchTitle('tit-bg-pt')" />
          <img v-else-if="$i18n.locale === 'ar'" :src="getMatchTitle('tit-bg-ar')" />
          <img v-else-if="$i18n.locale === 'tr'" :src="getMatchTitle('tit-bg-tr')" />
          <img v-else-if="$i18n.locale === 'fr'" :src="getMatchTitle('tit-bg-fr')" />
          <img v-else-if="$i18n.locale === 'id'" :src="getMatchTitle('tit-bg-id')" />
          <img v-else :src="getMatchTitle('tit-bg-en')" />
        </div>
      </div>

      <div class="main-con">
        <div class="act-date">
          <template v-if="actInfo">
            <div v-if="!actInfo.started" class="act-enddate">
              {{ $t('lang.commonM.k205') }}
              <i>{{ countdownResult.hours }}:{{ countdownResult.minutes }}:{{ countdownResult.seconds }}</i>
            </div>
            <div v-else class="act-enddate">{{ mexActStartTime }} - {{ mexActEndTime }}</div>
          </template>

          <div style="height: 12px"></div>
          <div class="act-range">{{ $t('lang.commonM.k333') }}</div>
        </div>

        <div v-if="actInfo && !!actInfo.started" class="points-rank">
          <div class="pr-item">
            <div>{{ $t('lang.commonM.k221') }}</div>
            <div v-if="actInfo">{{ actInfo.score || 0 }}</div>
          </div>
          <div style="width: 15px"></div>
          <div class="pr-item">
            <div>{{ $t('lang.commonM.k222') }}</div>
            <template v-if="actInfo">
              <div v-if="!actInfo.rank">--</div>
              <div v-else>{{ actInfo.rank }}</div>
            </template>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k218') }}</span>
          </div>
          <div v-if="actInfo && !!actInfo.started" class="part-tips">{{ $t('lang.commonM.k244') }}</div>
          <div v-else class="part-tips">{{ $t('lang.commonM.k259') }}</div>
          <div class="national-gift">
            <div class="gift-round">
              <div class="gift-cost">+1 {{ $t('lang.commonM.k260') }}</div>
              <!-- todo -->
              <img src="@/assets/packageAssets/common/Pumpkin.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k334') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+3 {{ $t('lang.commonM.k260') }}</div>
              <img src="@/assets/packageAssets/common/Ring.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k211') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+5 {{ $t('lang.commonM.k260') }}</div>
              <!-- todo -->
              <img src="@/assets/packageAssets/common/CandyBag.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k335') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+15 {{ $t('lang.commonM.k260') }}</div>
              <img src="@/assets/packageAssets/common/Kiss.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k305') }}</div>
            </div>
            <div class="gift-round">
              <div class="gift-cost">+50 {{ $t('lang.commonM.k260') }}</div>
              <img src="@/assets/packageAssets/common/Treasure.png" alt="" />
              <div class="gift-name">{{ $t('lang.commonM.k306') }}</div>
            </div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k215') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k216') }}</div>
          <div class="part-percent">
            <div class="part-per-block">
              <div>
                <div class="part-per-tips">
                  <div>{{ $t('lang.commonM.k217') }}</div>
                  <span>{{ percentData.percent1.num }}/10</span>
                </div>
                <div class="part-per-bar">
                  <div class="part-per-track" :style="{ width: `${percentData.percent1.rate}%` }"></div>
                </div>
              </div>
              <div style="width: 100%; height: 20px"></div>
              <div>
                <div class="part-per-tips">
                  <div>{{ $t('lang.commonM.k217') }}</div>
                  <span>{{ percentData.percent2.num }}/15</span>
                </div>
                <div class="part-per-bar">
                  <div class="part-per-track" :style="{ width: `${percentData.percent2.rate}%` }"></div>
                </div>
              </div>
              <div style="width: 100%; height: 20px"></div>
              <div>
                <div class="part-per-tips">
                  <div>{{ $t('lang.commonM.k217') }}</div>
                  <span>{{ percentData.percent3.num }}/20</span>
                </div>
                <div class="part-per-bar">
                  <div class="part-per-track" :style="{ width: `${percentData.percent3.rate}%` }"></div>
                </div>
              </div>
            </div>
            <div style="width: 10px"></div>
            <div class="part-per-reward">
              <div>
                {{ percentData.percent1.reward }}
                <img :src="getMatchImg('beans')" />
              </div>
              <div style="width: 100%; height: 20px"></div>
              <div>
                {{ percentData.percent2.reward }}
                <img :src="getMatchImg('beans')" />
              </div>
              <div style="width: 100%; height: 20px"></div>
              <div>
                {{ percentData.percent3.reward }}
                <img :src="getMatchImg('beans')" />
              </div>
            </div>
          </div>
        </div>

        <div class="part-block">
          <div class="part-head">
            <span>{{ $t('lang.commonM.k218') }}</span>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k219') }}</div>
          <div class="national-reward">
            <div class="national-item">
              <div class="reward-num">No.1</div>
              <div class="reward-coins">
                {{ boardData.num1Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="national-item">
              <div class="reward-num">No.2</div>
              <div class="reward-coins">
                {{ boardData.num2Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="national-item">
              <div class="reward-num">No.3</div>
              <div class="reward-coins">
                {{ boardData.num3Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
            <div class="national-item">
              <div class="reward-num">No.4-10</div>
              <div class="reward-coins">
                {{ boardData.num4Reward }}
                <img class="coins-icon" :src="getMatchImg('beans')" />
              </div>
            </div>
          </div>

          <div class="btn-block" v-if="actInfo && actInfo.started">
            <div class="national-btn" @click="handleToRank">{{ $t('lang.commonM.k220') }}</div>
          </div>
        </div>

        <div class="btn-block" v-if="actInfo && !actInfo.started">
          <div class="national-btn" @click="handleGotIt">{{ $t('lang.gotit') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { holidayActBaseInfo } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'

// en
import vavaTitBgEn from './images/vava/female-bg-en.png'
import echoTitBgEn from './images/echo/female-bg-en.png'
import joychatTitBgEn from './images/joychat/female-bg-en.png'
import kikoTitBgEn from './images/kiko/female-bg-en.png'

// es
import vavaTitBgEs from './images/vava/female-bg-es.png'
import echoTitBgEs from './images/echo/female-bg-es.png'
import joychatTitBgEs from './images/joychat/female-bg-es.png'
import kikoTitBgEs from './images/kiko/female-bg-es.png'

// pt
import vavaTitBgPt from './images/vava/female-bg-pt.png'
import echoTitBgPt from './images/echo/female-bg-pt.png'
import joychatTitBgPt from './images/joychat/female-bg-pt.png'
import kikoTitBgPt from './images/kiko/female-bg-pt.png'

// tr
import vavaTitBgTr from './images/vava/female-bg-tr.png'
import echoTitBgTr from './images/echo/female-bg-tr.png'
import joychatTitBgTr from './images/joychat/female-bg-tr.png'
import kikoTitBgTr from './images/kiko/female-bg-tr.png'

// ar
import vavaTitBgAr from './images/vava/female-bg-ar.png'
import echoTitBgAr from './images/echo/female-bg-ar.png'
import joychatTitBgAr from './images/joychat/female-bg-ar.png'
import kikoTitBgAr from './images/kiko/female-bg-ar.png'

// fr
import vavaTitBgFr from './images/vava/female-bg-fr.png'
import echoTitBgFr from './images/echo/female-bg-fr.png'
import joychatTitBgFr from './images/joychat/female-bg-fr.png'
import kikoTitBgFr from './images/kiko/female-bg-fr.png'

// id
import vavaTitBgId from './images/vava/female-bg-id.png'
import echoTitBgId from './images/echo/female-bg-id.png'
import joychatTitBgId from './images/joychat/female-bg-id.png'
import kikoTitBgId from './images/kiko/female-bg-id.png'

export default {
  mixins: [countDown],
  data() {
    return {
      actInfo: null,
      packageName: '',
      percentData: {
        percent1: {
          num: 0,
          rate: 0,
          reward: 0
        },
        percent2: {
          num: 0,
          rate: 0,
          reward: 0
        },
        percent3: {
          num: 0,
          rate: 0,
          reward: 0
        }
      },
      boardData: {
        num1Reward: 0,
        num2Reward: 0,
        num3Reward: 0,
        num4Reward: 0
      },
      mexActStartTime: '',
      mexActEndTime: ''
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleToRule() {
      this.$router.push({ path: '/halloween2025-rules-female', query: { from: 'halloween2025-main-female' } })
    },
    handleToRank() {
      this.$router.push({ path: '/halloween2025-rank-female', query: { from: 'halloween2025-main-female' } })
    },
    handleGotIt() {
      this.closeWeb()
    },
    getMatchTitle(imgname) {
      const imgsMap = {
        'tit-bg-en': {
          vava: vavaTitBgEn,
          echo: echoTitBgEn,
          joychat: joychatTitBgEn,
          kiko: kikoTitBgEn
        },
        'tit-bg-es': {
          vava: vavaTitBgEs,
          echo: echoTitBgEs,
          joychat: joychatTitBgEs,
          kiko: kikoTitBgEs
        },
        'tit-bg-pt': {
          vava: vavaTitBgPt,
          echo: echoTitBgPt,
          joychat: joychatTitBgPt,
          kiko: kikoTitBgPt
        },
        'tit-bg-tr': {
          vava: vavaTitBgTr,
          echo: echoTitBgTr,
          joychat: joychatTitBgTr,
          kiko: kikoTitBgTr
        },
        'tit-bg-fr': {
          vava: vavaTitBgFr,
          echo: echoTitBgFr,
          joychat: joychatTitBgFr,
          kiko: kikoTitBgFr
        },
        'tit-bg-ar': {
          vava: vavaTitBgAr,
          echo: echoTitBgAr,
          joychat: joychatTitBgAr,
          kiko: kikoTitBgAr
        },
        'tit-bg-id': {
          vava: vavaTitBgId,
          echo: echoTitBgId,
          joychat: joychatTitBgId,
          kiko: kikoTitBgId
        }
      }

      // 按包名判断
      const appName = this.getAppName()
      if (this.appNameFlag('vava', appName)) {
        return imgsMap[imgname]['vava']
      }
      if (this.appNameFlag('echo', appName)) {
        return imgsMap[imgname]['echo']
      }
      if (this.appNameFlag('joychat', appName)) {
        return imgsMap[imgname]['joychat']
      }
      if (this.appNameFlag('kiko', appName)) {
        return imgsMap[imgname]['kiko']
      }
      if (this.appNameFlag('joylink', appName)) {
        return imgsMap[imgname]['joylink']
      }
      if (this.appNameFlag('goparty', appName)) {
        return imgsMap[imgname]['goparty']
      }
    },
    // 获取数据
    fetchData() {
      holidayActBaseInfo().then((resData) => {
        // resData.started = false
        this.actInfo = resData || null

        if (!this.actInfo) return

        if (this.actInfo.startTimestamp) {
          this.mexActStartTime = this.handletMoment(this.actInfo.startTimestamp, 'MM/DD HH:mm')
        }
        if (this.actInfo.endTimestamp) {
          this.mexActEndTime = this.handletMoment(this.actInfo.endTimestamp, 'MM/DD HH:mm')
        }

        // 初始化倒计时
        if (this.actInfo.countdown) {
          this.initCountDown(resData.countdown, !!this.actInfo.started)
        }

        if (this.actInfo.milestoneRewards && this.actInfo.milestoneRewards.length) {
          this.percentData.percent1.reward = this.actInfo.milestoneRewards[0] || 0
          this.percentData.percent2.reward = this.actInfo.milestoneRewards[1] || 0
          this.percentData.percent3.reward = this.actInfo.milestoneRewards[2] || 0
        }

        if (this.actInfo.leaderboardRewards && this.actInfo.leaderboardRewards.length) {
          this.boardData.num1Reward = this.actInfo.leaderboardRewards[0] || 0
          this.boardData.num2Reward = this.actInfo.leaderboardRewards[1] || 0
          this.boardData.num3Reward = this.actInfo.leaderboardRewards[2] || 0
          this.boardData.num4Reward = this.actInfo.leaderboardRewards[3] || 0
        }

        // 女主播 任务进度
        if (this.actInfo.score > 0 && this.actInfo.score <= 10) {
          this.percentData.percent1.num = this.actInfo.score
          this.percentData.percent1.rate = (+this.actInfo.score / 10) * 100

          this.percentData.percent2.num = this.actInfo.score
          this.percentData.percent2.rate = (+this.actInfo.score / 15) * 100

          this.percentData.percent3.num = this.actInfo.score
          this.percentData.percent3.rate = (+this.actInfo.score / 20) * 100
          return
        }

        if (this.actInfo.score > 10 && this.actInfo.score <= 15) {
          this.percentData.percent1.num = 10
          this.percentData.percent1.rate = 100

          this.percentData.percent2.num = this.actInfo.score
          this.percentData.percent2.rate = (+this.actInfo.score / 15) * 100

          this.percentData.percent3.num = this.actInfo.score
          this.percentData.percent3.rate = (+this.actInfo.score / 20) * 100
          return
        }

        if (this.actInfo.score > 15 && this.actInfo.score <= 20) {
          this.percentData.percent1.num = 10
          this.percentData.percent1.rate = 100

          this.percentData.percent2.num = 15
          this.percentData.percent2.rate = 100

          this.percentData.percent3.num = this.actInfo.score
          this.percentData.percent3.rate = (+this.actInfo.score / 20) * 100
          return
        }

        if (this.actInfo.score > 20) {
          this.percentData.percent1.num = 10
          this.percentData.percent1.rate = 100

          this.percentData.percent2.num = 15
          this.percentData.percent2.rate = 100

          this.percentData.percent3.num = 20
          this.percentData.percent3.rate = 100
          return
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.holiday-main-root {
  width: 100%;
  min-height: 100vh;
  background: #29093c;

  .custom-nav-block {
    background: url(./images/main-bg.png) top left / 100% auto no-repeat;
  }

  .national-con {
    .national-head {
      width: 100%;
      position: relative;
      .head-img-back {
        width: 100%;
      }
      .head-img {
        position: absolute;
        top: 75px;
        z-index: 9;
        padding-top: 10px;
        width: 100%;
        img {
          display: block;
          width: 100%;
        }
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      padding-bottom: 79px;
      margin-top: -290px;

      .act-date {
        width: 355px;
        height: 87px;
        margin: 0 auto;
        border-radius: 12px;
        border: 0.5px solid rgba(208, 164, 255, 0.5);
        background: rgba(177, 94, 255, 0.2);
        backdrop-filter: blur(10.873126983642578px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .act-enddate {
          font-family: TikTok Sans;
          font-weight: 600;
          font-size: 17px;
          color: #d7cae1;
          line-height: 22px;
          text-align: right;
          i {
            color: #f69933;
          }
        }
        .act-range {
          font-family: TikTok Sans;
          font-weight: 400;
          font-size: 15px;
          color: #d7cae1;
          line-height: 20px;
          text-align: right;
        }
      }

      .points-rank {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        .pr-item {
          width: 170px;
          height: 66px;
          padding: 10px;
          background: #442753;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          div:nth-child(1) {
            font-family: TikTok Sans;
            font-weight: 400;
            font-size: 15px;
            color: #d7cae1;
            line-height: 20px;
          }
          div:nth-child(2) {
            font-family: TikTok Sans;
            font-weight: bold;
            font-size: 20px;
            color: #d7cae1;
            line-height: 24px;
          }
        }
      }

      .part-block {
        width: 355px;
        min-height: 250px;
        margin: 16px auto 0;
        padding-bottom: 24px;
        background: #442753;
        border-radius: 12px;
        .part-head {
          width: 355px;
          line-height: 42px;
          background: #5b2856;
          border-radius: 12px 12px 0px 0px;
          text-align: center;
          span {
            font-family: Tienne;
            font-size: 17px;
            font-weight: 700;
            background: linear-gradient(0deg, #f69933 18%, #ffe76c 77.27%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .part-tips {
          width: 100%;
          padding: 16px;
          font-family: TikTok Sans;
          font-weight: 400;
          font-size: 15px;
          color: #d7cae1;
          line-height: 20px;
          font-style: normal;
        }
        .national-gift {
          width: 100%;
          min-height: 30px;
          margin: 10px auto 16px;
          padding: 0 10px;
          display: flex;
          align-items: flex-start;
          justify-content: space-evenly;
          .gift-round {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .gift-cost {
              background: linear-gradient(180deg, #ffde97 0%, #fef4d0 100%);
              border-radius: 19px;
              padding: 2px 4px;
              min-width: 36px;
              font-family: TikTok Sans;
              font-weight: 600;
              font-size: 8px;
              color: #833d01;
              line-height: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            img {
              width: 40px;
              height: 40px;
              margin-top: 6px;
            }
            .gift-name {
              font-family: TikTok Sans;
              font-weight: 400;
              font-size: 12px;
              color: #d7cae1;
              line-height: 16px;
              margin-top: 14px;
              text-align: center;
            }
          }
        }
        .national-reward {
          width: 100%;
          padding: 0 16px;
          min-height: 116px;
          margin: 0 auto;

          .national-item {
            font-family: TikTok Sans;
            font-weight: 400;
            font-size: 15px;
            color: #d7cae1;
            line-height: 20px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
            .reward-coins {
              display: flex;
              align-items: center;
              font-weight: bold;
              color: #f69933;
              .coins-icon {
                width: 16px;
                height: 16px;
                margin-left: 4px;
              }
            }
          }
        }
        .part-percent {
          width: 100%;
          padding: 0 16px 20px;
          display: flex;
          &:last-child {
            padding-bottom: 0;
          }
          .part-per-block {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: space-around;
            > div {
              width: 100%;
              .part-per-tips {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 4px;
                div {
                  font-family: TikTokSans;
                  font-weight: 400;
                  font-size: 15px;
                  color: #d7cae1;
                  line-height: 20px;
                }
                span {
                  font-family: TikTokSans;
                  font-weight: 400;
                  font-size: 15px;
                  color: #d7cae1;
                  line-height: 20px;
                }
              }
              .part-per-bar {
                width: 100%;
                height: 10px;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 5px;
                .part-per-track {
                  width: 10px;
                  height: 10px;
                  background: #f8a348;
                  border-radius: 5px;
                }
              }
            }
          }
          .part-per-reward {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: space-around;
            div {
              display: flex;
              align-items: center;

              font-family: TikTokSans;
              font-weight: bold;
              font-size: 17px;
              color: #f69933;
              line-height: 22px;
              text-align: center;
              img {
                width: 20px;
                height: 20px;
              }
            }
          }
        }
      }
      .task-block {
        padding: 0 16px;
        .part-tips-b {
          font-family: TikTok Sans;
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          margin-top: 32px;
          text-align: left;
        }
        .part-task {
          margin-top: 13px;
          font-family: TikTok Sans;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
        }
      }

      .btn-block {
        display: block;
        width: 100%;
        margin: 30px auto 8px;
        text-align: center;
        .national-btn {
          min-width: 275px;
          display: inline-block;
          padding: 0 15px;
          background: #f8a348;
          border-radius: 27px;
          font-family: TikTok Sans;
          font-weight: 500;
          font-size: 17px;
          color: #482800;
          line-height: 42px;
          text-align: center;
          &.btn-disable {
            color: #edeef2;
            background: #a4a9bd;
          }
        }
      }
    }
  }
}

.act-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .dia-bg {
    width: 315px;
    border-radius: 16px;
    background: 442753;

    .con-block {
      width: 315px;
      border-radius: 16px;
      // background: url(./images/dia-bg.png) top left / 100% auto no-repeat;
      padding: 35px 30px 30px;

      .gifts-tit {
        line-height: 20px;
        text-align: center;

        span {
          text-align: center;
          -webkit-text-stroke-width: 0.5px;
          -webkit-text-stroke-color: #320070;
          font-family: Tienne;
          font-size: 24px;
          font-weight: 700;
          background: linear-gradient(0deg, #f69933 18.18%, #ffe76c 77.27%);
          background-clip: text;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }

      .gifts {
        // margin-top: 24px;
        margin-bottom: 20px;
        width: 100%;
        padding: 16px;
        border-radius: 8px;
        // border: 1px solid #fffad7;
        // background: linear-gradient(180deg, rgba(32, 164, 56, 0.2) 0%, rgba(241, 255, 48, 0.2) 100%);
        // box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1) inset;

        display: flex;
        align-items: center;
        justify-content: center;

        .gift-gap {
          width: 12px;
        }

        & > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .img-wrap {
            width: 40px;
            height: 40px;
            padding: 5px;
            border-radius: 8px;
            background: rgba(255, 255, 255, 0.1);
            img {
              width: 100%;
            }
          }
          .rewards-name {
            font-family: TikTok Sans;
            font-weight: 400;
            font-size: 12px;
            color: #d7cae1;
            line-height: 22px;
            margin-top: 4px;
            text-align: center;
          }
          .rewards-count {
            font-family: TikTok Sans;
            font-weight: bold;
            font-size: 17px;
            color: #d7cae1;
            line-height: 22px;
            font-style: italic;
            margin-top: 2px;
          }
        }
      }
      .gifts-confirm {
        width: 255px;
        line-height: 40px;
        padding: 10px;
        border-radius: 30px;
        background: #f8a348;

        font-family: Inter;
        font-size: 20px;
        font-weight: bold;
        color: #482800;
        line-height: 20px;
        text-align: center;
      }
    }
  }
}
</style>
